<template>
    <kgr-searchable-dropdown
        v-show="!loading"
        ref="departmentSearchableDropdown"
        display="extendedName"
        :label="label"
        :options="filteredDepartments"
        :value="value"
        :loading="loading"
        :initial-option="value"
        :inline="inline"
        :placeholder="defaultText"
        :clearable="clearable"
        @post-input="onInput($event)"
    />
</template>

<script>
import Department from '../../../../js/dto/Department';
import DepartmentRepository from '../../../../js/repository/DepartmentRepository';
import SearchableDropdown from './SearchableDropdown.vue';

export default {
    components: {
        'kgr-searchable-dropdown': SearchableDropdown,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        value: {
            type: Department,
            required: false,
            default: () => {
                return null;
            }
        },
        excludedIds: {
            type: Array,
            required: false,
            default: () => {
                return []
            },
        },
        defaultText: {
            type: String,
            required: false,
            default: null
        },
        hideLabel: {
            type: Boolean,
            required: false,
            default: false,
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
        excludeIfBasicDataNotViewable: {
            type: Boolean,
            required: false,
            default: false,
        },
        clearable: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            selection: null,
            loading: true,
            departments: [],
            excludedDepartmentIds: this.excludedIds
        }
    },
    computed: {
        label() {
            return this.hideLabel ? null : this.$t('department');
        },
        flattenedDepartments() {
            return this.extractChildDepartments(this.departments, []);
        },
        filteredDepartments() {
            return this.flattenedDepartments.filter(department => this.excludedDepartmentIds.indexOf(department.id) === -1);
        }
    },
    watch: {
        value: {
            handler(department) {
                if (!department || !department?.id) {
                    return
                }

                if (!this.selection || this.selection.id !== department.id) {
                    this.reload();
                }
            },
            deep: true,
            intermediate: true,
        }
    },
    created() {
        this.reload();
    },
    methods: {
        reload() {
            DepartmentRepository
                .findAll(this.clubId)
                .then(data => {
                    this.loading = false;
                    this.departments = data;
                    if (this.excludeIfBasicDataNotViewable) {
                        this.flattenedDepartments.map(department => {
                            if (!department.isViewable) {
                                this.excludedDepartmentIds.push(department.id);
                            }
                        });
                    }
                    if (this.value) {
                        this.filteredDepartments.forEach(department => {
                            if (department.id === this.value.id) {
                                this.selection = department;
                                this.$refs.departmentSearchableDropdown.selectOption(department);
                            }
                        });
                    }

                    this.$emit('optionsLoaded', this.flattenedDepartments);
                })
                .catch(() => this.$notify.error('error.loadingData'));
        },
        extractChildDepartments(childDepartments, departments) {
            childDepartments.forEach(department => {
                departments.push(department);
                departments = this.extractChildDepartments(department.childDepartments, departments);
            });

            return departments;
        },

        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        },
    }
}
</script>
